import { useGetNurseryModal } from 'v2/resources/hooks/services/nursery/useNursery';
import { IUseModalNursery } from '../types';

const useModalNursery = ({ data }: IUseModalNursery) => {
  const { data: nursery, isLoading: isLoadingNursery } = useGetNurseryModal({
    cycleId: data.cycleId,
    pondId: data.pondId,
  });

  return { nursery, isLoadingNursery };
};
export default useModalNursery;
